module.exports = __webpack_public_path__ + "static/2-9aaf994f6b9dbbac43d77ca4ac74f153.jpg";